import styled from 'styled-components'

export const ContentSection = styled.div`
  border-top: 1px solid ${ (props) => props.theme.colors.partingLine };
  padding-top: 10px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;

  .title {
    font-size: 22px;
    color: ${ (props) => props.theme.colors['standard-schwarz'] };
  }

  .no-padding {
    padding: 0;
  }

  .content {
    padding-right: 0;

    @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
      padding-left: 0;
    }
  }
`
